import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import type { MainSmsAccountFindInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-find.dto';
import { MainSmsIntegrationTypeEnum } from '@zaoblako/shared/modules/integration/enums/main.sms.integration.type.enum';
import { SmsGateEnum } from '@zaoblako/shared/modules/integration/enums/sms.gate.enum';
import type { SmsSenderFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing-settings/sms-sender-form.dto';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-newsletter-sms-sender-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './newsletter-sms-sender-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterSmsSenderSingleSelectComponent implements OnChanges {
  @Input() public smsSender = <SmsSenderFormInterface>{};
  @Output() public smsSenderChange = new EventEmitter<SmsSenderFormInterface>();

  public selectedSms: MainSmsAccountFindInterface;

  @Input() public styleClass: string;
  @Input() public showClear = false;

  @Input() public isError = false;

  @Input() public arraySms: MainSmsAccountFindInterface[] = [];
  @Input() public appendTo: string;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.smsSender?.currentValue) {
      this.selectedSms = this.smsSender.mainSmsAccount;
    }
    if (changes.arraySms?.currentValue) {
      this.arraySms = this.arraySms.filter((sms) => sms.type === MainSmsIntegrationTypeEnum.SMS);
    }
  }

  public selectSms(sms: MainSmsAccountFindInterface) {
    const smsSender: SmsSenderFormInterface = { ...this.smsSender };
    smsSender.mainSmsAccount = sms;
    smsSender.gate = SmsGateEnum.MAIN_SMS;
    this.smsSender = smsSender;
    this.smsSenderChange.emit(smsSender);
  }

  public toSms(sms: any): MainSmsAccountFindInterface {
    return sms as MainSmsAccountFindInterface;
  }
}
